import { useLinkTo } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useAtomValue } from "jotai";
import React, { useEffect } from "react";

import { Loader } from "@whoosh/design-system/src/components/display";
import { useTodaysDate } from "@whoosh/utilities/src/dates";

import { navigationRef_atom } from "../../features/Navigation/atoms";
import { sessionClubsAtom } from "../../features/Session";
import { BaseNavigatorParamList } from "../../navigators/BaseNavigator/types";

type TodaysTeeSheetScreenProps = NativeStackScreenProps<
  BaseNavigatorParamList,
  "TodayTeeSheetHack"
>;

/**
 * This exists purely to temporarily get around a deep linking issue
 */
export const TodaysTeeSheetScreen = ({
  route,
  navigation,
}: TodaysTeeSheetScreenProps) => {
  const navigationRef = useAtomValue(navigationRef_atom);
  const userClubs = useAtomValue(sessionClubsAtom);

  const linkTo = useLinkTo();
  const today = useTodaysDate();
  /**
   * This is a very gross hack that will handle correctly routing us deep to todays tee sheet.
   *
   * It is needed for a live customer however the actual fix of not conditionally rendering
   * our navigators is much harder.
   *
   * What this does is reflect the route into navigation state, which, for some reason survives the conditionally
   * rendered navigators and ends up getting there (though the URL is still messed up.)
   *
   * The listener is there so that if we hit the back button right away and re-focus this page, we end up at "home" as we should
   */
  useEffect(() => {
    if (userClubs) {
      if (navigationRef?.isReady()) {
        if (userClubs.length === 0) {
          navigation.navigate("Unauthenticated");
        } else {
          const defaultClub = userClubs[0];
          const unsubscribe = navigation.addListener("focus", () => {
            navigation.navigate("Club", {
              clubSlug: defaultClub.slug,
              screen: "Home",
              params: { screen: "MainHome" },
            });
          });
          navigation.navigate("Club", {
            clubSlug: defaultClub.slug,
            screen: "Agenda",
            params: { facilitySlug: "golf-course", date: today },
          });

          return unsubscribe;
        }
      }
    }
  }, [navigationRef, route, linkTo, today, navigation, userClubs]);

  return <Loader />;
};
